// extracted by mini-css-extract-plugin
module.exports = {"xstream_C":"C_xstream_C__gJGCf"};